import StandaloneAlbumCustomPrintConfigurator from './views/StandaloneAlbumCustomPrintConfigurator';

const albumCustomPrintServiceRoutes = [
  {
    path: '/album-custom-prints/:albumCustomPrintId',
    exact: true,
    component: StandaloneAlbumCustomPrintConfigurator,
  },
];

export default albumCustomPrintServiceRoutes;
